import { styled } from '@ori-ui/mui';

import { UnifiedSkeleton } from '../../styles';
import { QR_CODE_HEIGHT, QR_CODE_WIDTH } from './constants';

export const QRCodeSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  width: QR_CODE_WIDTH,
  height: QR_CODE_HEIGHT,
  borderRadius: theme.shape.borderRadius,
}));
